import parseDate from 'date-fns/parse';
import isValidDate from 'date-fns/isValid';
import differenceInDays from 'date-fns/differenceInDays';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import get from 'lodash/get';

const genericError = ['generic-error'];
const requiredFeedback = ['This field is required'];

export const zipValidations = {
  isValid(code = '') {
    return !code || !!code.toString().match(/^\d{5}$/);
  },
  errors: genericError,
  feedback: ["Hmm.. we can't find that zipcode"],
};

export const presenceValidations = {
  isValid(value, required) {
    return !required || (!!value && value !== '');
  },
  errors: genericError,
  feedback: requiredFeedback,
};

export const dateValidations = {
  isValid(date) {
    const hypotheticalDate = parseDate(date, 'MM/DD/YYYY');

    // Date should exist and be in the past
    return (
      isValidDate(hypotheticalDate) &&
      differenceInDays(new Date(), hypotheticalDate) > 0
    );
  },
  errors: genericError,
  feedback: ['Enter a valid date (MM/DD/YYYY)'],
};

export const passwordValidations = {
  errors: genericError,
  feedback: ['Invalid password.'],
};

// For config-requested validations
const validationLib = {
  zip: zipValidations,
  presence: presenceValidations,
  date: dateValidations,
  password: passwordValidations,
};

export const getValidationFn = (type, key) => {
  const validation = validationLib[type];

  return validation
    ? ({ attemptedSubmit, ...data }) => {
        const isValid = validation.isValid(get(data, key), attemptedSubmit);
        return {
          isValid,
          errors: validation.errors,
          feedback: isValid ? null : validation.feedback,
        };
      }
    : undefined;
};
